<template lang="pug">
    div(style="width:100%" class="watchlist-grid-container")
        AgGridVue(
            ref="agGridVueContainer"
            :context="context"
            style="position:relative; height: 700px;"
            :frameworkComponents="frameworkComponents"
            :class="{'ag-theme-dark':$vuetify.theme.isDark,'ag-theme-balham':!$vuetify.theme.isDark}"
            id="watchlist"
            gridApi=null
            gridColumnApi=null
            :gridOptions="gridOptions"
            :defaultColDef="defaultColDef"
            :animateRows="true"
            :postProcessPopup="postProcessPopup"
            :columnDefs="columnDefs"
            :getRowHeight="getRowHeight"
            :rowData="watchlists"
            @sortChanged="saveColumnUserSetting"
            @gridColumnsChanged="saveColumnUserSetting"
            @columnResized="saveColumnUserSetting"
        )

        TradePlanPopup(v-if="showTradePlanPopup" ref="showTradePlanPopupElement" :stock_id="stock_id")

        div(v-show="!this.userSubscribed" style="position: absolute; bottom: 15px; right:10px;")
            PremiumButton( ref="myPremiumButton")
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-dark.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import WatchedSinceDropDown from "./WatchedSinceDropDown";
import TradePlanState from "./TradePlanState.vue";
import TradePlanPopup from "./TradePlanPopup.vue";
import UserDiaryDropDown from "./UserDiaryDropDown";
import TagDropDown from "./TagDropDown.vue";
import PremiumButton from "../../components/PremiumButton";
import moment from "moment";
import _ from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ResearchIcon from "./ResearchIcon.vue";
import TradePlanIcon from "./TradePlanIcon.vue";
import Conviction from "./Conviction.vue";
import AddColumnBtn from "./AddColumnBtn.vue";
import Ticker from "../../components/Ticker.vue";
import IconDocumentEdit from '@/components/customIcons/IconDocumentEdit.vue';

const helper = require("../../util/helper.js");

export default {
    name: "ViewModeList",
    props: {
        watchlists: Array
    },
    components: {
        AgGridVue,
        ResearchIcon,
        IconDocumentEdit,
        TradePlanIcon,
        WatchedSinceDropDown,
        TradePlanState,
        TradePlanPopup,
        UserDiaryDropDown,
        TagDropDown,
        Conviction,
        PremiumButton,
        AddColumnBtn,
    },
    data() {
        const thisVal = this;
        return {
            stock_id: 0,
            showTradePlanPopup: false,
            tradePlanPopupX: 0,
            tradePlanPopupY: 0,
            missing_researchSum: 0,
            researchSum: 0,
            context: {},
            postProcessPopup: null,
            windowWidth: 0,
            windowHeight: 0,
            is_firstMounted: false,
            defaultColDef: {
                cellClass: 'number-cell',
                resizable: true
            },
            gridOptions: {
                headerHeight: 50,
                rowHeight: 50,
                suppressRowTransform: true,
                statusBar: {
                    statusPanels: [
                        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
                        { statusPanel: 'agAggregationComponent' },
                        // { statusPanelParams: {
                        //     // possible values are: 'count', 'sum', 'min', 'max', 'avg'
                        //     aggFuncs: ['min', 'max', 'avg']}
                        // }

                    ],
                },
                // groupIncludeFooter: true,
                // groupIncludeTotalFooter: true
            },
            columnDefs: [
                {headerName: this.$t('Ticker'),
                    field: "ticker",
                    cellRenderer: 'ticker',
                    cellRendererParams: {
                        action : this.goToStock.bind(this),
                    },
                    suppressMenu: true,
                    width: 85,
                    cellClass: 'pt-3',
                    cellStyle: {whiteSpace: "nowrap"},
                    hide: false,
                },
                {headerName: this.$t('Name'),
                    field: "Name",
                    suppressMenu: true,
                    sortable: true,
                    width: 120,
                    cellClass: 'pt-2',
                    hide: false,
                },
                {headerName: this.$t('Sector'),
                    field: "Sector",
                    suppressMenu: true,
                    sortable: true,
                    width: 120,
                    cellClass: 'pt-2',
                    hide: false,
                    valueFormatter: (params) => {
                        return helper.sectorNameConverter(params.value, this);
                    }
                },
                {headerName: this.$t('last_earnings'),
                    field: "EarningsDate",
                    suppressMenu: true,
                    sortable: true,
                    width: 96,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                    cellStyle: {textAlign: "right"},
                },
                {headerName: this.$t('next_earnings'),
                    field: "next_earnings_date",
                    suppressMenu: true,
                    sortable: true,
                    width: 100,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                    cellStyle: {textAlign: "right"},
                },
                {headerName: this.$t('price_eod'),
                    field: "price_today",
                    suppressMenu: true,
                    sortable: true,
                    width: 88,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                    cellStyle: {textAlign: "right"},
                },
                {headerName: this.$t('last_eps'),
                    field: "Eps",
                    suppressMenu: true,
                    sortable: true,
                    width: 71,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                    cellStyle: {textAlign: "right"},
                    pinnedRowCellRenderer: function (params) { return '<strong>' + params.data.Eps + '</strong>'},
                },
                {headerName: this.$t('last_sales'),
                    field: "Sales",
                    suppressMenu: true,
                    sortable: true,
                    width: 78,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                    cellStyle: {textAlign: "right"},
                },
                {headerName: this.$t('Watched_Since'),
                    field: "Watched Since",
                    cellRenderer: 'watchedSinceDropDown',
                    suppressMenu: true,
                    sortable: true,
                    width: 100,
                    hide: false,
                },
                {headerName: "∆%",
                    field: "∆%",
                    cellRenderer: function (params) {
                        return params.value + ' %';
                    },
                    cellStyle: {textAlign: "right"},
                    suppressMenu: true,
                    sortable: true,
                    width: 67,
                    cellClass: 'pt-2',
                    hide: false,
                    type: 'rightAligned',
                },
                {headerName: this.$t('Conviction'),
                    field: "Conviction",
                    cellRenderer: 'conviction',
                    cellRendererParams: {
                    },

                    suppressMenu: true,
                    sortable: true,
                    width: 120,
                    hide: false,
                },
                {headerName: this.$t('research'),
                    field: "ticker",
                    cellRenderer: 'researchIcon',
                    cellRendererParams: {
                        action : this.goToResearch.bind(this),
                    },
                    suppressMenu: true,
                    sortable: true,
                    width: 76,
                    hide: false,
                },
                {headerName: this.$t('trade_plan'),
                    field: "ticker",
                    cellRendererFramework: 'TradePlanState',
                    suppressMenu: true,
                    sortable: true,
                    width: 84,
                    hide: false,
                },
                {headerName: this.$t('Trade_Journal'),
                    field: "ticker",
                    suppressMenu: true,
                    sortable: true,
                    width: 214,
                    cellRendererFramework: UserDiaryDropDown,
                    hide: false,
                },
                {headerName: this.$t('My_Tags'),
                    field: "tags",
                    suppressMenu: true,
                    sortable: true,
                    width: 255,
                    cellRendererFramework: TagDropDown,
                    hide: false,
                },

                {headerName: "",
                    width: 50,
                    field: '',
                    headerComponentFramework: 'AddColumnBtn',
                    // suppressFilterButton: false,
                    lockVisible: false,
                    pinned: "right",
                    resizable: false,
                    suppressMenu: true,
                    suppressMovable: true,
                    // suppressSorting : true,
                    hide: false
                },
                {headerName: "",
                    // suppressFilterButton: false,
                    lockVisible: false,
                    pinned: "right",
                    resizable: false,
                    suppressMenu: true,
                    suppressMovable: true,
                    // suppressSorting : true,
                    hide: false,
                    field: '',
                    width: 50,
                    cellRenderer: (data) => {
                        if (thisVal.watchlistID !== -1 || this.$route.params.id === 0) {
                            const element = document.createElement('div');
                            element.className = 'saveRemoveStockBlock';
                            element.style.color = 'white';
                            element.innerHTML = `
                                <span id="remove${data.value}" class="remove-button-layout">
                                    ${thisVal.trashCanIcon()}
                                </span>
                            `;
                            const removeButton = element.querySelector('#remove' + data.value);

                            removeButton.addEventListener('click', async () => {
                                const rowData = JSON.parse(JSON.stringify(data.node.data));
                                await thisVal.clickRemoveButton(rowData);
                            });

                            return element;
                        }
                    }
                },
            ],
            gridColumSaveTrigger: null,
            saveColumnEnabled: false
        };
    },
    beforeMount() {
        this.frameworkComponents = {
            researchIcon: ResearchIcon,
            researchIconNew: IconDocumentEdit,
            tradePlanIcon: TradePlanIcon,
            conviction: Conviction,
            tagDropDown: TagDropDown,
            addColumnBtn: AddColumnBtn,
            userDiaryDropDown: UserDiaryDropDown,
            watchedSinceDropDown: WatchedSinceDropDown,
            ticker: Ticker
        };

        this.context = {
            componentParent: this
        };
    },
    computed: {
        ...mapGetters([
            "getAllStocks",
            "getWatchlists",
            "getUserCurrentWatchlistId",
            "getWatchlistItems",
            "getWatchlistJoins",
            "getWL_columns"
        ]),
        watchlistID() {
            this.getFooterValues(); // it is needed when you go to another WL page
            return this.$route.params.id ? this.$route.params.id : -1;
        },
        paywallCriteria() {
            // user.type === 'new' || user.type === 'freemium'
            return (this.user.type === 'new' || this.user.type === 'freemium') && this.user.subscription_id === null;
        },
        user() {
            return JSON.parse(localStorage.getItem('user'))
        },
        averageNumberOfDays() {
            let totalNumberOfDays = 0;

            for(const item of this.watchlists) {
                const given = moment(item.Research.watched_since);
                const current = moment().startOf('day');
                const days = moment.duration(given.diff(current)).asDays().toFixed(0).charAt(0) === '-' ? parseInt(-moment.duration(given.diff(current)).asDays().toFixed(0)) : parseInt(moment.duration(given.diff(current)).asDays().toFixed(0));

                totalNumberOfDays += days;
            }

            const averageNumberOfDays = (totalNumberOfDays / this.watchlists.length).toFixed(0);

            return !isNaN(averageNumberOfDays) ? averageNumberOfDays : 0;
        },
        deltaProcentAverage() {
            let deltaCounter = 0;
            let deltaProcentSum = 0;

            for(const item of this.watchlists) {
                if(item['∆%'] !== "") {
                    deltaCounter++;
                    deltaProcentSum += item['∆%'];
                }
            }

            const deltaProcentAverage = (deltaProcentSum / deltaCounter).toFixed(0);

            return deltaProcentAverage;
        },
        researchStats() {
            const researchObject = {
                document: 0,
                missing: 0
            };

            for(const item of this.watchlists) {
                if(item.Research.research_state === 'EXISTS') {
                    researchObject.document += 1;
                } else {
                    researchObject.missing += 1;
                }
            }

            return researchObject;
        },
        userSubscribed: {
            get() {
                return this.$store.getters.getUserSubscribed;
            },
        },
    },
    methods: {
        ...mapActions([
            "removeStocksFromWLJ",
            "removeStocksFromWLI",
            "saveWLColumns",
            "loadCompanyAnalysts"
        ]),
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        tradePlanOpenClosedState(event) {
            // console.log('outside...');

            const clickedElement = event.target;
            const rect = clickedElement.getBoundingClientRect();
            const topY = rect.top;
            const leftX = rect.left;

            this.tradePlanPopupY = topY;
            this.tradePlanPopupX = leftX;

            try {
                if(this.$refs.showTradePlanPopupElement.$el !== undefined) {
                    const elem = this.$refs.showTradePlanPopupElement.$el;
                    const outsideClick = elem.contains(event.target);

                    // console.log(outsideClick);

                    this.showTradePlanPopup = outsideClick;
                }
            } catch (error) {
                console.log(error.message);
            }
        },
        saveColumnUserSetting() {
            if (this.saveColumnEnabled) {
                if (this.gridColumSaveTrigger != null) {
                    clearTimeout(this.gridColumSaveTrigger);
                }
                this.gridColumSaveTrigger = setTimeout(() => {
                    this.saveColumnConfig()
                }, 100);
            }
        },
        saveColumnConfig() {
            let WL_columns = this.getWL_columns;
            let columnsConf = this.gridOptions.columnApi.getColumnState();
            WL_columns.columnsConf = columnsConf;
            let data = {
                user_id: this.user.user_id,
                content: JSON.stringify(WL_columns),
                feature: 'WATCHLIST'
            }
            this.saveWLColumns(data);
        },
        setAddColumn(columns) {
            var cols = this.gridOptions.columnApi.columnController.columnDefs;
            cols.forEach(element => {
                element.hide = false;
                if (columns.includes(element.headerName)) {
                    element.hide = true;
                }
            });

            this.gridOptions.api.setColumnDefs([cols[cols.length - 1]]);
            this.gridOptions.api.setColumnDefs(cols);
            this.gridOptions.api.redrawRows();
            this.is_firstMounted = true;

            let WL_columns = this.getWL_columns;
            let columnsConf = this.gridOptions.columnApi.getColumnState();
            WL_columns.columns = columns;
            WL_columns.columnsConf = columnsConf;
            let data = {
                user_id: this.user.user_id,
                content: JSON.stringify(WL_columns),
                feature: 'WATCHLIST'
            }
            this.saveWLColumns(data);
        },
        goToStock(ticker) {
            let stock = this.getAllStocks.find(s=> s.ticker === ticker);
            this.$router.push({name: 'landing-page.stock-detail', params: {stock_id: stock.stock_id}});
        },
        getRowHeight(params) {
            if (params.data.tags) {
                let tags = JSON.parse(params.data.tags);
                if (params.data.tags && tags && tags.length > 2) {
                    if (tags.length % 2 == 1) {
                        return parseInt(tags.length /2 + 1) * 32 + 10;
                    } else {
                        return (tags.length) /2 * 32 + 10;
                    }
                } else {
                    return 50;
                }
            } else {
                return 50;
            }
        },
        async clickRemoveButton(item) {
            // Open register popup if visitor
            if(this.user.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            await this.removeStocksFromWLJ({
                watchlist_id: this.watchlistID,
                stock_id: item.stock_id,
                user_id: this.user.user_id
            });
            let WL = this.getWatchlistJoins.find(join => join.stock_id == item.stock_id);
            if (!WL) {
                await this.removeStocksFromWLI({
                    watchlist_id: this.watchlistID,
                    stock_id: item.stock_id,
                    user_id: this.user.user_id
                });
            }
            this.getFooterValues();
        },
        goToResearch(ticker) {
            // console.log(ticker);

            let stock = this.getAllStocks.find(s=> s.ticker === ticker);

            // console.log(stock);

            this.$router.push({name: 'landing-page.stock-detail', params: {stock_id: stock.stock_id}, query: {tab: 1}});

            setTimeout(() => {
                const element = document.getElementById('openDrawerElement');

                element.click();
            }, 500);
        },
        trashCanIcon() {
            return `
                <svg class="set-trash-can-container" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="set-trash-can-color" stroke="#000000" d="M3.33203 5H16.6654L15.3487 16.85C15.3036 17.2578 15.1096 17.6346 14.8039 17.9083C14.4982 18.182 14.1023 18.3334 13.692 18.3333H6.30536C5.89506 18.3334 5.49917 18.182 5.19349 17.9083C4.88781 17.6346 4.69383 17.2578 4.6487 16.85L3.33203 5Z" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                    <path class="set-trash-can-color" stroke="#000000" d="M6.12083 2.62251C6.25563 2.33664 6.46892 2.095 6.73584 1.92576C7.00275 1.75653 7.31229 1.66667 7.62833 1.66667H12.3717C12.6879 1.66651 12.9976 1.75629 13.2646 1.92554C13.5317 2.09479 13.7451 2.33652 13.88 2.62251L15 5.00001H5L6.12083 2.62251Z" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                    <path class="set-trash-can-color" stroke="#000000" d="M1.66602 5H18.3327" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                    <path class="set-trash-can-color" stroke="#000000" d="M8.33203 9.16667V13.3333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                    <path class="set-trash-can-color" stroke="#000000" d="M11.666 9.16667V13.3333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            `;
        },
        getFooterValues() {
            this.researchSum = 0;
            this.missing_researchSum = 0;

            this.gridOptions.api.forEachNode((rowNode) => {
                if(rowNode.data !== undefined) {
                    this.researchSum ++;
                    if (rowNode.data.research_state == 'MISSING') {
                        this.missing_researchSum ++;
                    }
                }
            });

            const researchSumElement = document.getElementById('research_sum');
            researchSumElement.innerHTML = this.researchSum;

            const missing_research_Element = document.getElementById('missing_research_sum');
            missing_research_Element.innerHTML = this.missing_researchSum;
        }
    },
    async mounted() {
        console.log('mounted() - props watchlists in ViewModelList.vue======', this.watchlists);

        document.addEventListener('click', this.tradePlanOpenClosedState);

        setTimeout(async () => {
            let WL_columns = this.getWL_columns;
            if (WL_columns.columnsConf) {
                this.gridOptions.columnApi.applyColumnState({
                    state: WL_columns.columnsConf,
                    applyOrder: true,
                });
            } else {
                this.gridOptions.columnApi.applyColumnState({
                    state: this.columnDefs,
                    applyOrder: true,
                });
            }
            this.saveColumnEnabled = true;

            await this.loadCompanyAnalysts();
        }, 50);

        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        const urlParams = new URLSearchParams(window.location.search);

        this.is_firstMounted = false;

        if(urlParams.get('stock_id') !== null && urlParams.get('tab') !== null) {
            const stock_id = parseInt(urlParams.get('stock_id'));
            const tab = parseInt(urlParams.get('tab'));

            this.$router.push({name: 'landing-page.stock-detail', params: { stock_id }, query: { tab }});
        }

        // Footer of ag-grid
        const agStatusBarCenter = document.getElementsByClassName('ag-status-bar-left')[0];
        const plChild = document.createElement('span');
        plChild.style.paddingLeft = "20px";
        plChild.style.paddingRight = "4px";
        plChild.style.paddingTop = "8px";
        plChild.style.paddingBottom = "8px";
        plChild.innerHTML = '<span ref="eValue" id="research_sum" class="ag-status-name-value-value">0</span>' +
                            '<span>  Documents</span>' +
                            '<div>' +
                            '<span ref="eValue" id="missing_research_sum" class="ag-status-name-value-value">0</span>' +
                            '<span>  Missing</span>' +
                            '</div>'
                            ;

        agStatusBarCenter.append(plChild);

        this.getFooterValues();
    },
    watch: {
        watchlists() { // it is needed when you add WLI
            this.getFooterValues()
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.tradePlanOpenClosedState);

        this.saveColumnConfig();
    }
}
</script>

<style>



.dropDown2 {
    display: none;
    z-index: 0;
    position: absolute;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 0 0 0 ;
    margin: -5px 0 0 40px;
    min-width: 380px;
    box-shadow: 10px 13px 48px -4px rgba(0,0,0,0.49);
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
}

.movepanel{
    left: 950px !important;
    top: 30px;
}


</style>

<style scoped>
>>> span:hover .set-trash-can-color {
    stroke: red;
}

>>> .v-icon:hover > .set-research-no-container > .set-research-no-color {
    fill: #8EC690;
}

>>> .set-trash-can-color {
    stroke: #333333;
}

>>> span:hover {
    cursor: pointer;
}

>>> .set-trash-can-container {
    width: 23px;
    height: 23px;
}

>>> .remove-button-layout {
    display: inline-block;
    margin-top: 5px;
}

>>> .ag-watermark {
    opacity: 0;
}

.remove-watchlist-item-design {
    background-color: white;
    color: gray;
}

.remove-watchlist-item-design:hover {
    color: red;
}
</style>
